/**
 *
 * @param element
 */
import { ReactElement } from 'react';

/**
 * 获取最小重复单元背景size
 */
export function getPattFillPresetSize(element: ReactElement, scaleW, scaleH) {
    const { width, height } = element?.props?.children?.[0]?.props;
    return { patternWidth: parseInt(width, 10) / scaleW, patternHeight: parseInt(height, 10) / scaleH };
}
